import { useLazyQuery } from '@apollo/client';
import React from 'react';
import { SIGN_UP_METHODS } from '../../shared/constants';
import { signInWithFacebook } from '../../shared/firebase';
import { CREATE_USER_FROM_FIREBASE } from '../../shared/gqlQueries/createUserFromFirebase';
import { setAuthToken } from '../../shared/helpers/localStorageHelper';

const FacebookSignUp = ({
  nextStep,
  setEmail,
  setFirstName,
  setLastName,
  setErrors,
  setSignUpMethod,
}) => {
  const [createUser, { data }] = useLazyQuery(CREATE_USER_FROM_FIREBASE, {
    fetchPolicy: 'network-only',
    onCompleted: () => {
      console.log('[FacebookSignUp] createUser', data);
      nextStep();
      setSignUpMethod(SIGN_UP_METHODS.GOOGLE);
    },
    onError: (error) => {
      // console.log('[GoogleSignUp] error createUser gql', error.graphQLErrors);
      error.graphQLErrors?.forEach((err) =>
        setErrors((prevArr) => [...prevArr, err.message || 'Error creating user']),
      );
    },
  });

  function handleSignUp() {
    return signInWithFacebook()
      .then(async (data) => {
        // User signed in successfully.
        try {
          console.log('[FacebookSignUp] user', data.user);
          const token = await data.user.getIdToken();
          setAuthToken(token);
          setEmail(data.user.email);
          setFirstName(data.user.displayName?.split(' ')[0] || '');
          setLastName(data.user.displayName?.split(' ')[1] || '');
          createUser();
        } catch (e) {
          console.error(e);
        }
      })
      .catch((e) => setErrors((prevArr) => [...prevArr, e.message || 'Facebook sign up error']));
  }
  return (
    <button
      className="shadow w-64 p-3 text-white bg-blue-700 font-medium rounded-sm focus:outline-none"
      onClick={async () => await handleSignUp()}
    >
      Sign up with Facebook
    </button>
  );
};

export default FacebookSignUp;
